import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { IconProps } from "@material-ui/core/Icon";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import React from "react";

const useStyles = makeStyles(
  theme => ({
    cardContent: {
      "&:last-child": {
        padding: theme.spacing(2, 3)
      },
      display: "grid",
      gridColumnGap: theme.spacing(3),
      gridTemplateColumns: "1fr 64px",
      height: "100%"
    },
    cardSpacing: {
      [theme.breakpoints.down("sm")]: {
        marginBottom: theme.spacing(1)
      }
    },
    cardSubtitle: {
      fontSize: 12,
      height: "20px",
      lineHeight: 0.9
    },
    cardTitle: {
      fontSize: 15,
      fontWeight: 500 as 500
    },
    centerText: {
      alignItems: "center",
      display: "flex",
      justifyContent: "center"
    },
    icon: {
      color: theme.palette.primary.contrastText,
      fontSize: 54,
      margin: ".5rem .3rem"
    },
    value: {
      textAlign: "right"
    }
  }),
  { name: "RemittanceInfoCard" }
);

interface RemittanceInfoCardProps {
  icon: React.ReactElement<IconProps>;
  title: string;
  children?: React.ReactNode;
}

const RemittanceInfoCard: React.FC<RemittanceInfoCardProps> = props => {
  const { children, title } = props;

  const classes = useStyles(props);

  return (
    <Card className={classes.cardSpacing}>
      <CardContent className={classes.cardContent}>
        <div>
          <Typography className={classes.cardTitle} variant="subtitle1">
            {title}
          </Typography>
          <Typography
            className={classes.cardSubtitle}
            variant="caption"
            color="textSecondary"
          ></Typography>
          <Typography
            className={classes.value}
            color="textPrimary"
            variant="h4"
          ></Typography>
        </div>
        <div className={classes.centerText}>
          <Typography variant="h2">{children}</Typography>
        </div>
      </CardContent>
    </Card>
  );
};
RemittanceInfoCard.displayName = "RemittanceInfoCard";
export default RemittanceInfoCard;
